import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from '../../../../../common/form/FormElements';
import { useTranslation } from 'react-i18next';
import { WarningFilled } from '@ant-design/icons';

const ErrorMessages = ({ errors }) => {
  const { t } = useTranslation();

  return (
    <>
      {errors && (
        <div className="error-message-container-comp">
          {Object.keys(errors).map((rowNumber) => {
            return (
              <div key={`row-${rowNumber}`}>
                <div className="icon-wrapper">
                  <WarningFilled />
                  <div className="row-message">
                    {t('Chyba v riadku č.')} {rowNumber}
                  </div>
                </div>

                {errors[rowNumber].map((message) => (
                  <ErrorMessage key={`row-${rowNumber}-${message}`}>
                    {message}
                  </ErrorMessage>
                ))}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

ErrorMessages.propTypes = {
  errors: PropTypes.any,
};

export default ErrorMessages;
